import { Award, BookOpen, ChevronRight, History, Play } from 'lucide-react';
import { Link } from 'react-router-dom';
import { formatRupees } from '../lib/subscribe';
import type { StudentCourse } from '../lib/types';
import { CourseArtwork, ProgressBar, StatePill } from './ui';

export function StudentCourseCard({ course, index, onOpen, catalogMode = false }: { course: StudentCourse; index: number; onOpen: () => void; catalogMode?: boolean }) {
  const price = Number(course.Price ?? 0);
  const showPurchase = course.CoursePaidType?.toLowerCase() === 'paid' && Number.isFinite(price) && price > 0;
  return <article className="course-card" onClick={onOpen} tabIndex={course.objectId.startsWith('fallback') ? -1 : 0} onKeyDown={(event) => event.key === 'Enter' && onOpen()}>
    <div className="course-card-main">
      <CourseArtwork index={index} icon={course.kind === 'test' ? 'play' : 'book'} image={course.CourseLogo} />
      <div className="course-card-copy">
        <h3>{course.CourseTitle}</h3>
        <span className="faculty">{course.faculty}</span>
        {!catalogMode && <div className="course-progress">
          <div><StatePill value={course.progress} completed={course.completed} /><span>{course.lessonCount} {course.kind === 'test' ? 'mock tests' : 'lectures'}</span></div>
          <ProgressBar value={course.progress} completed={course.completed} />
        </div>}
      </div>
    </div>
    {catalogMode ? <div className="course-card-foot"><span>{course.CoursePaidType || 'Course'}</span><button className="start"><BookOpen size={14} /> View course</button></div> : <div className="course-card-foot">
      <span><History size={13} /> {course.completed ? 'Completed' : course.lastStudied}</span>
      <button className={course.progress === 0 ? 'start' : ''}>{course.progress === 0 ? 'Start' : course.completed ? <><Award size={14} /> Certificate</> : <><Play size={14} /> Continue</>}</button>
    </div>}
    {showPurchase && <Link className="course-card-purchase" to={`/subscribe?courseId=${encodeURIComponent(course.objectId)}`} onClick={(event) => event.stopPropagation()}><strong>{formatRupees(price)}</strong><span>Purchase options</span><ChevronRight size={15} /></Link>}
    {course.completed && <div className="certificate-strip"><Award size={16} /><strong>Course certificate available</strong><span>View certificate</span></div>}
  </article>;
}
